import _ from 'lodash';
import moment from 'moment';
import { createSelector } from 'reselect';

import { State } from '../../../types';
import { WaiverState } from './waiversReducer';
import { Waiver } from '../../../../types/waiver';

function selectRoot(state: State): WaiverState {
  return state.entities.waivers.waivers;
}

export function selectLoading(state: State): boolean {
  return selectRoot(state).loading;
}

export function selectWaiverById(state: State, id: number): Waiver | undefined {
  return selectRoot(state).waiversById[id] ?? undefined;
}

export function selectWaiversById(state: State): any {
  return selectRoot(state).waiversById;
}

export const selectWaivers: (state: State) => Waiver[] = createSelector(
  selectWaiversById,
  waiversById =>
    _(waiversById)
      .values()
      .compact()
      .value(),
);

export const selectRecentWaivers: (state: State) => Waiver[] = createSelector(
  selectWaivers,
  waivers => {
    const oldestWaiverDate = moment().subtract(30, 'days');
    return _(waivers)
      .filter((waiver: Waiver) =>
        moment(waiver.publishedDate).isAfter(oldestWaiverDate),
      )
      .orderBy(['publishedDate'], ['desc'])
      .value();
  },
);

export const selectRecentWaiversByAirline: (state: State) => { [key: string]: Waiver[] } = createSelector(
  selectRecentWaivers,
  waivers => _.groupBy(waivers, 'issuingAirlineCode') || {},
);

export const selectRecentWaiversForAirline = (state: State) => (
  airline: string,
): Waiver[] => selectRecentWaiversByAirline(state)[airline] || [];
